import LocalizedStrings from 'react-localization';
import slovenian from './languages/sl';
import english from './languages/en';
import german from './languages/de';
import french from './languages/fr';
import croatian from './languages/hr';
import italian from './languages/it';

const locale = new LocalizedStrings({
	sl: slovenian,
	en: english,
	de: german,
	fr: french,
	hr: croatian,
	it: italian,
});
export default locale;
